// src/customer-form/GeneralFields.jsx
// Country comes first so the rest of the form can react to it.
import {
  translations,
  countryValues,
} from './constants';

function getLanguage(country) {
  if (country === 'Morocco') return 'ar';
  if (country === 'Senegal' || country === "Cote D'ivoire") return 'fr';
  return 'en';
}

export default function GeneralFields({ formData, handleChange, handleBlur, errors = {}, touched = {} }) {
  const lang = getLanguage(formData.country);
  const t = translations[lang];

  return (
    <div className="row2">
      {/* Country FIRST */}
      <div className={`field ${touched.country && errors.country ? 'has-error' : ''}`}>
        <label className="label">{t.country} <span className="required">*</span></label>
        {touched.country && errors.country && <div className="error-message">{errors.country}</div>}
        <select className="select" name="country" value={formData.country} onChange={handleChange} onBlur={handleBlur} required>
          <option value="">{t.selectCountry}</option>
          {t.countryOptions.map((name, i) => (
            <option key={countryValues[i]} value={countryValues[i]}>{name}</option>
          ))}
        </select>
      </div>

      <div className={`field ${touched.contactName && errors.contactName ? 'has-error' : ''}`}>
        <label className="label">{t.contactName} <span className="required">*</span></label>
        {touched.contactName && errors.contactName && <div className="error-message">{errors.contactName}</div>}
        <input className="input" name="contactName" value={formData.contactName} onChange={handleChange} onBlur={handleBlur} placeholder="e.g. John Doe" required />
      </div>

      <div className={`field ${touched.email && errors.email ? 'has-error' : ''}`}>
        <label className="label">{t.email} <span className="required">*</span></label>
        {touched.email && errors.email && <div className="error-message">{errors.email}</div>}
        <input className="input" type="email" name="email" value={formData.email} onChange={handleChange} onBlur={handleBlur} placeholder={t.emailPlaceholder} required />
      </div>

      <div className={`field ${touched.phone && errors.phone ? 'has-error' : ''}`}>
        <label className="label">{t.phone} <span className="required">*</span></label>
        {touched.phone && errors.phone && <div className="error-message">{errors.phone}</div>}
        <input className="input" type="tel" name="phone" value={formData.phone} onChange={handleChange} onBlur={handleBlur} placeholder="e.g. +234 800 000 0000" required />
      </div>
    </div>
  );
}
